import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";

import Level from "./level";
import SkeletonLevel from "./skeleton-level";
import AdLevel from "./ad-level";
import LevelWithIcon from "../extra-levels-screen/level-with-icon";
import {LOGOS_SCREEN} from '../../ducks/duck-screen'
import {initializeStatsInUnlockedLevel} from "../../ducks/duck-game";

const styles = theme => ({
	root: {

	},
	levelList: {
		'padding-bottom': '100px',
	}
});

class PlayScreen extends Component {
	constructor(props){
		super(props);

		if(props.isUnlocking){
			return
		}

		const { gameType, levelList, currentExtraLevel, unlockLevel, initializeStatsInUnlockedLevel } = props;
		console.log(levelList[gameType])
		console.log(levelList[gameType][0])
		if(gameType !== 'classic'
			&& levelList[gameType]
			&& levelList[gameType][0]
			&& levelList[gameType][0].collectedRiddles === undefined){

			initializeStatsInUnlockedLevel(gameType, 0);
			unlockLevel(gameType, currentExtraLevel.unlockLimit, true);
		}
	}
	currentPosition = 0;

	setCurrentPosition = ({ target }) => {
		this.currentPosition = target.scrollTop;
		// console.log(this.currentPosition)
	};

	componentDidMount() {
		const { updateScrollPosition, scrollPositions, gameType } = this.props;
		//zerujemy pozycje na liscie lóg
		updateScrollPosition(0, 'logoList');
		
		const container = document.querySelector('#play-container').closest("#animation-wrapper");
		container.addEventListener('scroll', this.setCurrentPosition);
		if(scrollPositions[gameType]){
			console.log(gameType, scrollPositions[gameType]);
			container.scrollTop = scrollPositions[gameType];
		} else {
			container.scrollTop = 0;
		}
	}

	componentWillUnmount() {
		const { updateScrollPosition, gameType } = this.props;
		const container = document.querySelector('#play-container');
		container.removeEventListener('scroll', this.setCurrentPosition);
		// console.log('pozycja logo-screen', this.currentPosition);
		// console.log(this.currentPosition, gameType);
		updateScrollPosition(this.currentPosition, gameType);
	}

	renderLevels = (gameTypeCollectedRiddles, levelList) => {

		const levels = levelList.map((level) => {
			if(level.levelIcon){
				return (
					<LevelWithIcon
						key={`level-${level.levelOrder}`}
						id={`level-${level.levelOrder}`}
						levelName={`Level ${level.levelOrder}`}
						color={level.color}
						levelIcon={level.levelIcon}
						riddleLimit={level.logosTo}
						unlockLimit={level.unlockLimit}
						collectedRiddles={level.collectedRiddles || 0}
						collectedPoints={level.collectedPoints || 0}
						riddlesCountingForUnlock={gameTypeCollectedRiddles}
						isUnlocked={gameTypeCollectedRiddles >= level.unlockLimit}
						isSound={this.props.isSound}
						isVibrate={this.props.isVibrate}
						onClick={() => {this.setLogosAndChangeScreen(`${level.logosFrom}-${level.logosTo}`, level)}}
					/>
				)
			} else {
				return (
					<Level
						key={`level-${level.levelOrder}`}
						id={`level-${level.levelOrder}`}
						levelId={`${level.levelOrder}`}
						color={level.color}
						logosFrom={level.logosFrom}
						logosTo={level.logosTo}
						unlockLimit={level.unlockLimit}
						collectedRiddles={level.collectedRiddles || 0}
						collectedPoints={level.collectedPoints || 0}
						gameTypeCollectedRiddles={gameTypeCollectedRiddles}
						isUnlocked={gameTypeCollectedRiddles >= level.unlockLimit}
						isSound={this.props.isSound}
						isVibrate={this.props.isVibrate}
						onClick={() => {this.setLogosAndChangeScreen(`${level.logosFrom}-${level.logosTo}`, level)}}
					/>
				);
			}
		});


		const adLevels = levels.slice();
		//TODO tutaj logika
		const index = this.getCorrectIndexForAd(levels.slice());
		adLevels.splice(index, 0, <AdLevel key={`ad-level-0`} id={`ad-level-0`}/>);
		console.log(adLevels);
		return adLevels
	};

	setLogosAndChangeScreen = (riddleRange = '1-30', level) => {
		const { getRiddlesFromRange,
			setCurrentRiddleRange,
			setCurrentLevel,
			push } = this.props;

		setCurrentLevel(level);
		getRiddlesFromRange(riddleRange);
		setCurrentRiddleRange(riddleRange);
		push(LOGOS_SCREEN);
	};

	getCorrectIndexForAd = (levels) => {
		if(levels.length === 0){
			return 0
		}

		const latestUnlockedLevelIndex = levels.reduce((latestUnlocked, level, index) => {
			if(level.props.isUnlocked){
				return index
			} else {
				return latestUnlocked
			}
		}, 0);

		if(latestUnlockedLevelIndex === 0){
			return 3
		} else if(latestUnlockedLevelIndex === 1 || latestUnlockedLevelIndex === 2){
			return 4
		} else {
			return latestUnlockedLevelIndex
		}

	}

	renderSkeletons = () => {
		return [...Array(10).keys()].map(i => {
			return (<SkeletonLevel
				key={`level-${i}`}
				id={`level-${i}`}
			/>)
		})
	}

	render(){

		const { classes,
			levelList,
			gameType,
			gameTypeCollectedRiddles,
			isDatabaseResetting } = this.props;

		const areLevelsDownloaded = levelList[gameType].length > 0
			&& levelList[gameType][0]["collectedPoints"] !== undefined
			&& isDatabaseResetting === false;
		const style = areLevelsDownloaded ? {} : { overflow: "hidden" };

		return (
			<div className={classes.root} id={"play-container"} style={style}>
				<List component="ul" className={classes.levelList}>
					{!areLevelsDownloaded && this.renderSkeletons()}
					{areLevelsDownloaded && this.renderLevels(gameTypeCollectedRiddles, levelList[gameType])}
				</List>
			</div>
		);
	}
}

PlayScreen.propTypes = {
	isDatabaseResetting: PropTypes.bool.isRequired,
	gameTypeCollectedRiddles: PropTypes.number.isRequired,
	isSound: PropTypes.bool.isRequired,
	isVibrate: PropTypes.bool.isRequired,
	isUnlocking: PropTypes.bool.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		levelList: PropTypes.string.isRequired,
	}).isRequired,

	levelList: PropTypes.object,
	scrollPositions: PropTypes.object.isRequired,
	currentExtraLevel: PropTypes.object.isRequired,

	push: PropTypes.func.isRequired,
	setCurrentRiddleRange: PropTypes.func.isRequired,
	getRiddlesFromRange: PropTypes.func.isRequired,
	setCurrentLevel: PropTypes.func.isRequired,
	unlockLevel: PropTypes.func.isRequired,
	initializeStatsInUnlockedLevel: PropTypes.func.isRequired,

};

export default withStyles(styles)(PlayScreen);
